/**
 * @generated SignedSource<<ff8e5a15830b1b9074f35e5d3693f991>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGlobal"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isGlobal",
        "variableName": "isGlobal"
      },
      {
        "kind": "Variable",
        "name": "itemId",
        "variableName": "itemId"
      },
      {
        "kind": "Variable",
        "name": "tagId",
        "variableName": "tagId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "removeItemToTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveItemToTagMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RemoveItemToTagMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "aeddb755e32ae0c4f6e34171dfe7b76a",
    "id": null,
    "metadata": {},
    "name": "RemoveItemToTagMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveItemToTagMutation(\n  $tagId: ID!\n  $itemId: ID!\n  $isGlobal: Boolean\n) {\n  removeItemToTag(tagId: $tagId, itemId: $itemId, isGlobal: $isGlobal) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "1b66bf8d8b4983f871d55a15b1b32b3c";

export default node;
